export default {
    name: 'QAlert',
    props: {
        icon: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        variant: {
            type: String,
            default: ''
        },
        closeButton: {
            type: Boolean,
            default: false
        },
        isHidden: {
            type: Boolean,
            default: false
        },
        duration: {
            type: Number,
            required: false
        },
        position: {
            type: [String, Array],
            required: false
        }
    },
    updated() {
        if (this.duration && !this.isHidden) {
            setTimeout(() => {
                this.isHidden = true;
                this.$parent.alert.isHidden = this.isHidden;
            }, this.duration);
        }
    },
    computed: {
        statusClass() {
            return this.variant ? 'is-' + this.variant : '';
        },
        positionClass() {
            if (this.position) {
                return 'alert-fixed ' + this.position;
            }
        }
    },
    methods: {
        onCloseClick() {
            this.isHidden = true;
        }
    }
};
